var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      ref: "userInfoDialog",
      staticClass: "userInfoDialog",
      style: { left: _vm.left + "px", top: _vm.getTop(_vm.top) },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "userInfo",
        },
        [
          _c(
            "div",
            { staticClass: "userInfoHeader" },
            [
              _c("AppAvatar", {
                attrs: {
                  avatar: _vm.avatar,
                  name: _vm.nick,
                  width: "60",
                  "no-name": true,
                },
              }),
              _c("div", { staticClass: "userInfoU" }, [
                _c(
                  "div",
                  { staticClass: "userInfoUName text_hidden_ellipsis" },
                  [_vm._v(_vm._s(_vm.filtersTextPhone(_vm.nick)))]
                ),
                _c(
                  "div",
                  { staticClass: "userInfoURemake" },
                  [
                    _c("span", { staticClass: "remake" }, [_vm._v("备注")]),
                    _vm.ifEdit
                      ? _c("el-input", {
                          staticStyle: { width: "196px", height: "24px" },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              )
                                return null
                              return _vm.sendRemake.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.remarks,
                            callback: function ($$v) {
                              _vm.remarks = $$v
                            },
                            expression: "remarks",
                          },
                        })
                      : _vm._e(),
                    !_vm.ifEdit && _vm.userInfo.remarks
                      ? _c(
                          "span",
                          { staticClass: "remakeText text_hidden_ellipsis" },
                          [_vm._v(_vm._s(_vm.userInfo.remarks))]
                        )
                      : _vm._e(),
                    !_vm.ifEdit
                      ? _c("i", {
                          staticClass: "el-icon-edit-outline",
                          on: { click: _vm.onhandleEdit },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
          _c("div", { staticClass: "userInfoBody" }, [
            _c("div", { staticClass: "userInfoBView" }, [
              _c("div", { staticClass: "formLabel" }, [_vm._v("手机号")]),
              _c(
                "div",
                { staticClass: "formValue" },
                [
                  _vm.userInfo.phoneNumber
                    ? _c("watchPhoneNumber", {
                        attrs: {
                          "phone-area-code": _vm.userInfo.phoneAreaCode,
                          "default-value": _vm.userInfo.phoneNumber,
                          params: _vm.userInfo,
                          "user-id": _vm.userInfo.traineeId,
                          "get-api": _vm.operationLogsWrite,
                        },
                      })
                    : _c("span", [_vm._v("--")]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "userInfoBView" }, [
              _c("div", { staticClass: "formLabel" }, [_vm._v("邮箱")]),
              _c(
                "div",
                { staticClass: "formValue" },
                [
                  _vm.userInfo.email
                    ? _c("watchPhoneNumber", {
                        attrs: {
                          "default-value": _vm.userInfo.phoneNumber,
                          params: _vm.userInfo,
                          "user-id": _vm.userInfo.traineeId,
                          "get-api": _vm.operationLogsWriteEmail,
                        },
                      })
                    : _c("span", [_vm._v("--")]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "userInfoBView" }, [
              _c("div", { staticClass: "formLabel" }, [_vm._v("微信号")]),
              _c("div", { staticClass: "formValue text_hidden_ellipsis" }, [
                _vm._v(_vm._s(_vm.userInfo.wechatId || "--")),
              ]),
            ]),
            _c("div", { staticClass: "userInfoBView" }, [
              _c("div", { staticClass: "formLabel" }, [_vm._v("注册日期")]),
              _c("div", { staticClass: "formValue" }, [
                _vm._v(_vm._s(_vm._f("filterTime")(_vm.userInfo.registerTime))),
              ]),
            ]),
            _c("div", { staticClass: "userInfoBView" }, [
              _c("div", { staticClass: "formLabel" }, [_vm._v("最近购买日期")]),
              _c("div", { staticClass: "formValue" }, [
                _vm._v(
                  _vm._s(_vm._f("filterTime")(_vm.userInfo.recentPurchaseTime))
                ),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }